import { createSlice } from "@reduxjs/toolkit"

export const storeListSlice = createSlice({
	name: "storeList",
	initialState: {
		stores: "",
		errors: [],
	},

	reducers: {
        getStore: (state, action) => {
            // console.log(action.payload);
			state.stores = action.payload
		},
		getStoreList: (state, action) => {
			// console.log(action.payload);
			state.stores = action.payload
		},
		getErrors: (state, action) => {
            // console.log(action.payload);
			state.errors = action.payload
		},
	},
})
export const {getStore, getStoreList, getErrors} = storeListSlice.actions

export default storeListSlice.reducer
